// Referral (affiliate) program utility
// Works together with BILLmanager counter pixel in public/index.html
// Counter pixel handles cookie tracking (cntid), this module handles
// preserving ?from= parameter across navigation and passing it to billing URLs

const REF_KEY = "netgrid_ref";

/**
 * Capture referral code from URL (?from=XXX) and save to localStorage
 */
export function captureReferralCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const from = params.get("from");
    if (from) {
      localStorage.setItem(REF_KEY, from);
    }
  } catch (e) {
    // localStorage may be unavailable
  }
}

/**
 * Get stored referral code (or null)
 */
export function getReferralCode() {
  try {
    return localStorage.getItem(REF_KEY);
  } catch (e) {
    return null;
  }
}

/**
 * Get cntid from cookie (set by BILLmanager counter pixel)
 */
function getCntid() {
  try {
    var match = document.cookie.match(/(?:^|;\s*)cntid=([^;]*)/);
    return match ? match[1] : null;
  } catch (e) {
    return null;
  }
}

/**
 * Build billing URL with referral code and sesid
 */
export function getBillingUrl(func, lang) {
  var url = "https://billing.netgrid.host/billmgr?func=" + func + "&lang=" + lang;
  var ref = getReferralCode();
  if (ref) {
    url += "&from=" + encodeURIComponent(ref);
  }
  var sesid = getCntid();
  if (sesid) {
    url += "&sesid=" + encodeURIComponent(sesid);
  }
  return url;
}

/**
 * Open billing in new tab with referral code
 */
export function openBilling(func, lang) {
  window.open(getBillingUrl(func, lang), "_blank");
}
